import React from "react";
import { tt } from "../../../../../utils/i18n/i18n";
import KC_Heading2 from "../../../../../designsystem/typography/KC-Heading/KC_Heading2";

const CTAHeader: React.FC = () => (
  <div id="premium-cta-header" className="mb-4">
    <div className="d-flex flex-column">
      <KC_Heading2 text={tt("cta_editor_heading_2")} />
    </div>
  </div>
);

export default CTAHeader;
